<template>
  <div class="overview">
    <section class="account_usage">
      <AccountUsage />
    </section>
    <section class="volumes">
      <Volumes />
    </section>
    <section class="volumes_monitoring">
      <div class="margin_top">
        <AccountAllocation />
      </div>
    </section>
  </div>
</template>

<script>
import AccountUsage from './overview/UsageAccount.vue'
import Volumes from './volumes/Volumes.vue'
import AccountAllocation from './allocation/AccountAllocation.vue'

export default {
    name: 'Overview',
    components: {
        AccountUsage,
        Volumes,
        AccountAllocation
    },
}
</script>
<style lang="scss" scoped>
section {
  margin-bottom: 40px;
}
</style>
